import moment from 'moment';

import { DATE_FORMAT_CONSTANTS } from '@finder/shared/constants/date.constants';
/**
 * Apply the format settings to given time string
 *
 * @method      formatOutputTime
 * @argument    timeString: string
 */
const formatScheduleTime = (timeString: string): string => {
    let formattedTime = timeString;
    const momentObj = moment(timeString, DATE_FORMAT_CONSTANTS.timeParseFormat);
    // Just use one moment object
    if (momentObj.isValid()) {
        formattedTime = momentObj.format(DATE_FORMAT_CONSTANTS.timeOutputFormat);
    }

    return formattedTime;
};

export default formatScheduleTime;
